import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AuthService } from '@core/auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Only inject auth token for API requests
  if (!req.url.includes('/api/')) {
    return next(req);
  }

  const authService = inject(AuthService);

  // Use async getValidToken() to ensure the token is fresh (auto-refresh if needed)
  return from(authService.getValidToken()).pipe(
    switchMap(token => {
      if (token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }
      return next(req);
    })
  );
};
